<script>
  import { onMount } from "svelte";

  // Service
  import { OperationCommonInfoService } from "../../Core/Service/OperationCommonInfoService";
  import { SheetTourProductService } from "../Service/SheetTourProductService";
  import { ServerMultiTourApiService } from "../../../Tour/Service/ServerMultiTourApiService";

  // Support
  import { modifyProductViewHeightSupport } from "../../Core/Support/ModifyProductViewHeightSupport";
  import { OperationEntryTabSupport } from "../Support/OperationEntryTabSupport";
  import { goToTopSupport } from "../../Core/Support/GoToTopSupport";

  // Component
  import FlagshipProductComponent from "../Component/FlagshipProduct/FlagshipProductComponent.svelte";
  import NavBarComponent from "../Component/NavBar/NavBarComponent.svelte";
  import ProductListComponent from "../Component/Product/ProductListComponent.svelte";
  import BlogListComponent from "../Component/Blog/BlogListComponent.svelte";
  import ActiveRuleComponent from "../Component/ActiveRule/ActiveRuleComponent.svelte";

  export let google_spread_id = "";
  export let common_config_sheet_id = "";

  let flagship_sheets_list = []; // 主打商品
  let active_rule_sheets_list = []; // 活動辦法
  let theme_product_detail_list = []; // 各主題商品
  let theme_blog_detail_list = []; // 各主題文章推薦

  onMount(async () => {
    await getOperationCommonConfigInfoController();
    await getThemeProductController();
    await modifyProductViewHeight(0);
    await checkEntryTab();
  });


  /***
   * 取得 “公用區塊” 資訊
   */
  async function getOperationCommonConfigInfoController() {
    let operationCommonInfoService = OperationCommonInfoService();

    //  取得主打產品及注意事項設定檔
    let OperationCommonConfig = await operationCommonInfoService.getOperationCommonConfig(google_spread_id, common_config_sheet_id);

    // 取得各主題主打商品及注意事項內容
    flagship_sheets_list = await operationCommonInfoService.getFlagShipInfo(google_spread_id, OperationCommonConfig.flagship_product.sheet_id);
    active_rule_sheets_list = await operationCommonInfoService.getActiveRules(google_spread_id, OperationCommonConfig.active_rule.sheet_id);
  }


  /***
   * 取得 “主題產品” 資訊
   * 取得 “文章推薦” 資訊
   */
  async function getThemeProductController() {
    // 取得 google sheet 產品資訊服務
    let sheetTourProductService = SheetTourProductService();

    // 從後端取得主題產品資訊服務
    let serverMultiTourApiService = ServerMultiTourApiService();

    // 從 google sheet 取得預設產品資訊
    theme_product_detail_list = await sheetTourProductService.getThemeTourDetail(google_spread_id, flagship_sheets_list);

    // 取得 Server 產品資訊
    theme_product_detail_list = await serverMultiTourApiService.getTourLatestInfoFromServer(theme_product_detail_list);

    // 從 google sheet 取得預設推薦文章資訊
    theme_blog_detail_list = await sheetTourProductService.getThemeBlogDetail(google_spread_id, flagship_sheets_list);
  }

  /***
   * 產品視窗高度依各主題產品高度訂定
   */
  async function modifyProductViewHeight(num) {
    await modifyProductViewHeightSupport(num);
  }

  /***
   * 檢查網址是否有帶 query
   */
  async function checkEntryTab() {
    let nav_page = await OperationEntryTabSupport();
    if (nav_page) {
      modifyProductViewHeight(nav_page);
    }
  }

  /***
   * 點選頁籤時跳至產品最高點
   */
  function setAnchor() {
    goToTopSupport();
  }
</script>

<div class="tourPage_theme">
  <input type="radio" id="nav1" name="slidenav" checked />
  <input type="radio" id="nav2" name="slidenav" />
  <input type="radio" id="nav3" name="slidenav" />
  <input type="radio" id="nav4" name="slidenav" />
  <input type="radio" id="nav5" name="slidenav" />

  <!-- 主題頁籤 START -->
  <NavBarComponent
    {modifyProductViewHeight}
    {setAnchor}
    nav_item_list={flagship_sheets_list} />
  <!-- 主題頁籤 END -->

  <!-- 主打商品 START -->
  <FlagshipProductComponent let:product_index={index} {flagship_sheets_list}>
    <!-- 產品列表 START -->
    <ProductListComponent
      {index}
      theme_product_list={theme_product_detail_list} />
    <!-- 產品列表 END -->

    <!-- 推薦文章 START -->
    <BlogListComponent {index} theme_blog_list={theme_blog_detail_list} />
    <!-- 推薦文章 END -->
  </FlagshipProductComponent>
  <!-- 主打商品 END -->
</div>

<!-- 注意事項 START -->
<ActiveRuleComponent {active_rule_sheets_list} />
<!-- 注意事項 END -->
